import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";

import "./tours.scss";

function ToursList() {
  const navigate = useNavigate();
  const [tours, setTours] = React.useState([]);
  const [hoveredRow, setHoveredRow] = React.useState(null);
  const breadcrumbItems = [
    { title: "Tours", link: "#" },
    { title: "Tours List", link: "#" },
  ];

  React.useEffect(() => {
    fetchTours();
  }, []);

  const fetchTours = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/tours`);
      const data = await response.json();
      console.log('Tours data:', data); // Add this to debug
      setTours(data.data || data); // Handle both data formats
    } catch (error) {
      console.error('Error fetching tours:', error);
    }
  };

  const handleEdit = (tour) => {
    navigate(`/edit-tour/${tour._id}`, { state: { tour } });
  };

  const handleDelete = async (tourId) => {
    if (window.confirm("Are you sure you want to delete this tour?")) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/tours/${tourId}`, {
          method: 'DELETE'
        });
        
        if (response.ok) {
          // Remove the tour from the state
          setTours(tours.filter(cat => cat._id !== tourId));
        } else {
          console.error('Failed to delete tour');
        }
      } catch (error) {
        console.error('Error deleting tour:', error);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Tour List"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end mb-4">
                    <Link to="/create-tour">
                      <Button color="primary">
                        <i className="ri-add-line align-middle me-1"></i> Add Tour
                      </Button>
                    </Link>
                  </div>
                  <div className="table-responsive">
                    <Table className="table table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>State / Country Name</th>
                          <th>Tour Name</th>
                          <th>Tour Image</th>
                          
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tours.map((tour, index) => (
                          <tr 
                            key={tour._id}
                            className="tour-row"
                          >
                            <td>{tour._id}</td>
                            <td>{tour?.category_name}</td>
                            <td>{tour?.tour_name}</td>
                            <td>
                              <img
                                src={`${config.IMAGE_URL}/${tour.tour_image}`}
                                alt={tour.tour_name}
                                width="50"
                                height="50"
                                className="rounded"
                              />
                            </td>
                            <td>
                              <span className="badge bg-success">
                                Active
                              </span>
                            </td>
                            <td>
                                <button 
                                  className="tour-action-buttons"
                                  onClick={() => handleEdit(tour)}
                                >
                                  <i className="ri-pencil-fill"></i>
                                </button>
                                <button 
                                  className="tour-action-buttons"
                                  onClick={() => handleDelete(tour._id)}
                                >
                                  <i className="ri-delete-bin-fill"></i>
                                </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default ToursList;
